import { TrackProperty } from '../services/columnSettings/playlistColumns';

enum Source {
  /** Signifies absence of a track */
  Null,
  File,
  YouTube,
  OneDrive,
  GoogleDrive,
  Dropbox,
  Spotify,
  SoundCloud,
  Podcast,
  /**
   * Appended, and it has to stay appended: the numeric values are what the
   * library file stores, so inserting anywhere above renumbers every track
   * already saved.
   */
  Mixcloud,
}
export const Sources: {
  [P in Source]: {
    name: string;
    /**
     * Columns not applicable to Source.
     * Width from these columns will be added to previous column.
     */
    skipColumns?: TrackProperty[];
  };
} = {
  [Source.Null]: {
    name: 'Null',
  },
  [Source.File]: {
    name: 'File',
  },
  [Source.YouTube]: {
    name: 'YouTube',
    skipColumns: [TrackProperty.album, TrackProperty.artist, TrackProperty.genre],
  },
  [Source.OneDrive]: {
    name: 'OneDrive',
  },
  [Source.GoogleDrive]: {
    name: 'GoogleDrive',
  },
  [Source.Dropbox]: {
    name: 'Dropbox',
  },
  [Source.Spotify]: {
    name: 'Spotify',
  },
  [Source.SoundCloud]: {
    name: 'SoundCloud',
  },
  [Source.Podcast]: {
    name: 'Podcast',
  },
  [Source.Mixcloud]: {
    name: 'Mixcloud',
    skipColumns: [
      // Mixcloud has no albums. The artist column shows the host or the
      // uploader and genre shows the show's first tag, so both of those stay.
      TrackProperty.album,
    ],
  },
};

export default Source;
